module.exports = __webpack_public_path__ + "img/menu-icon.42ae44b1.svg";